import { useState } from 'react';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';
import { ReceiptStatus } from '../../types/drawer.types';
import { Receipt } from '../../store/ducks/freight/types';

export default function usePatchReceiptStatus() {
  const [loading, setLoading] = useState(false);

  async function register({
    status,
    receiptId,
    cartId,
    freightId,
  }: {
    status: ReceiptStatus;
    receiptId: string;
    cartId: string;
    freightId: string;
  }): Promise<Receipt | undefined> {
    try {
      setLoading(true);
      const response = await api.patch(
        `v1/backoffice/freights/${freightId}/carts/${cartId}/receipts/${receiptId}`,
        {
          receiptStatus: status,
        },
      );

      if (response.status === 200) {
        toast.success(ToastMessages.deliveries.success.patchReceiptStatus);
        return response.data;
      }
    } catch (error) {
      toast.error(ToastMessages.deliveries.error.patchReceiptStatus);
    } finally {
      setLoading(false);
    }
  }
  return { register, loading };
}
